import { buildWebsiteUrl, useOrgSlugInfo } from '@/hooks/useOrgSlug';
import { domainStage, useDomainsData } from '@/hooks/useDomainAdmin';

/**
 * The business's public website: their own domain once it's live, otherwise
 * their free <slug>.thepolishedversion.com address. Null until known (or for a
 * platform admin with no business selected).
 */
export function useTenantWebsiteUrl(orgId: string | null | undefined): string | null {
  const { data: slugInfo } = useOrgSlugInfo(orgId);
  const { data: domains } = useDomainsData(orgId);
  const live = domains?.find((d) => domainStage(d) === 'live');
  if (live) return `https://${live.domain}`;
  return slugInfo?.slug ? buildWebsiteUrl(slugInfo.slug) : null;
}
